import store from "@/store/index.js";
import router from "@/router/index.js";
import _ from "lodash";

//检测路由是否有权限访问
export function checkUrl(url, parentUrl) {
  // console.log("url-----", url);
  // console.log("parentUrl---", parentUrl);
  //先检测router里面是否有该路由，没有则直接404
  let cPath = [];
  function getTreeItem(tree = [], path) {
    if (tree.length !== 0) {
      for (let i = 0; i < tree.length; i++) {
        if (tree[i].path == path) {
          cPath.push(tree[i]);
          break;
        }
        if (tree[i].children && tree[i].children.length >= 1) {
          getTreeItem(tree[i].children, path);
        }
      }
    }
  }
  getTreeItem(router.options.routes, url);
  if (cPath.length == 0) {
    return "404";
  }

  //如果是系统默认的路由就不做判断直接跳转
  if (
    (_.isString(parentUrl) && parentUrl == "system") ||
    (_.isArray(parentUrl) && _.indexOf(parentUrl, "system") > -1)
  ) {
    return "url";
  }

  //再检测菜单里面是否有该路由，没有则直接403
  let menuList = store.getters["layoutStore/getMenuDataSort"];
  let cMenu = [];

  for (let element of menuList) {
    // console.log("menu ele", element);
    if (element.children.length > 0) {
      cMenu = element.children.filter(item => {
        // // return item.url == parentUrl;
        // console.log("parentUrl: ", parentUrl);
        // console.log("item.path: ", item.path);
        return (
          (_.isString(parentUrl) && parentUrl == item.path) ||
          (_.isArray(parentUrl) && _.indexOf(parentUrl, item.path) > -1)
        );
      });
    } else {
      if (
        (_.isString(parentUrl) && parentUrl == element.path) ||
        (_.isArray(parentUrl) && _.indexOf(parentUrl, element.path) > -1)
      ) {
        cMenu = [element];
      }
    }

    if (cMenu.length > 0) {
      break;
    }
  }
  if (cMenu.length == 0) {
    return "403";
  }

  return "url";
}

//是否登录
export function isLogin() {
  let token = sessionStorage.getItem("token");
  return token;
}

//检查按钮的权限
export function checkButton(auth) {
  let authList = store.getters["layoutStore/getAuthData"];
  return authList.indexOf(auth) > -1;
}
